module.exports = __webpack_public_path__ + "img/cigna.3ec9b5a9.png";